import {css} from 'styled-components';

export const DETAILS_PANEL_WIDTH = 448;

export const DETAILS_PANEL_WIDTH_PX = `${DETAILS_PANEL_WIDTH}px`;

export const PANEL_HEIGHT_WITHOUT_HEADER = 'calc(100vh - 66px - 48px)';

// Page chrome above an expense details panel: the 66px app header plus 24px of page padding top
// and bottom.
export const EXPENSE_PANEL_PAGE_OFFSET = 114;

export const EXPENSE_PANEL_TABS_BAR_HEIGHT = 42;

/**
 * Declares `--expense-panel-content-height`: the height of an expense details panel's scroll area,
 * i.e. the viewport less the page chrome above the panel, the tabs bar and the panel header
 * (`--expense-panel-top-height`, measured and set by `ExpenseDetailsPanel`). `ExpenseLogTab` reads
 * it so its comment box rides the bottom of the panel.
 *
 * @param {number|string} [offset] - Space above the panel's tabs bar: px as a number, or any CSS
 *   length (e.g. a `var()` expression) as a string. Defaults to the standard page chrome.
 */
export const expensePanelContentHeightVar = (offset = EXPENSE_PANEL_PAGE_OFFSET) => css`
  --expense-panel-content-height: calc(100vh - ${typeof offset === 'number' ? `${offset}px` : offset} - ${EXPENSE_PANEL_TABS_BAR_HEIGHT}px - var(--expense-panel-top-height, 0px));
`;

/**
 * Declares `--expense-panel-content-height` and caps the element at it. Use it on the element
 * that scrolls.
 *
 * @param {number} [offset] - See `expensePanelContentHeightVar`.
 */
export const expensePanelScrollArea = (offset) => css`
  ${expensePanelContentHeightVar(offset)}
  max-height: var(--expense-panel-content-height);
`;

export const vendorDetailsPanelStyles = css`
  .vendor-details {
    .vendor-details-panel-body {
      max-height: calc(100vh - (66px + 56px + 24px * 2 + 8px));
    }
  }
`;
